import * as React from 'react'
import { Row, Col, Button, Icon } from 'antd'
import { inject, observer } from 'mobx-react'
import { SingleLocation } from './SingleLocation/SingleLocation'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import Helmet from 'react-helmet'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  showAddLocation: boolean
}

@inject('currentCompanyStore')
@observer
export class Locations extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showAddLocation: false,
    }
  }

  componentWillUnmount = () => this.props.currentCompanyStore?.getGlobalLocations()

  setShowAddLocation = (showAddLocation: boolean) => this.setState({ showAddLocation })

  render() {
    const locations = this.props.currentCompanyStore!.locations || []

    return (
      <Row className='white-rounded-container'>
        <Helmet>
          <title>Settings | Locations</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <Col lg={14} md={24}>
          <p className='text-muted mb-4'>Locations each hold their own inventory levels.</p>

          {locations.map((location, index) => {
            return (
              <SingleLocation
                key={index}
                index={index}
                location={location}
                onSave={() => this.setShowAddLocation(false)}
              />
            )
          })}

          {this.state.showAddLocation && (
            <SingleLocation
              index={locations.length}
              onSave={() => this.setShowAddLocation(false)}
            />
          )}

          <Button
            type='primary'
            onClick={() => this.setShowAddLocation(!this.state.showAddLocation)}
          >
            <Icon type='plus' />
            Add a location
          </Button>
        </Col>
      </Row>
    )
  }
}
